export default {
  root: {
    class: [
      "bg-surface-0 dark:bg-surface-800",
      "text-surface-700 dark:text-white/80",
      "**:data-[pc-name=pcfilter]:w-full",
    ],
  },
  wrapper: {
    class: ["overflow-auto"],
  },
  container: {
    class: [
      // Spacing
      "m-0 p-0",

      // Misc
      "list-none overflow-auto",
    ],
  },
  nodeContent: ({ context, props }) => ({
    class: [
      // Flex and Alignment
      "flex items-center",
      "group transition-colors bg-transparent hover:bg-dss-surface-100 rounded-md box-shadow-lg",
      "px-4",

      // Shape
      "rounded-md",

      // Colors
      "text-surface-600 dark:text-white/70",
      { "bg-highlight": context.selected },

      // States
      {
        "hover:bg-surface-50 dark:hover:bg-surface-700/40":
          (props.selectionMode == "single" ||
            props.selectionMode == "multiple") &&
          !context.selected,
      },

      // Transition
      "transition-shadow duration-500",

      {
        "cursor-pointer select-none":
          props.selectionMode == "single" || props.selectionMode == "multiple",
      },
    ],
  }),
  nodeToggleButton: ({ context }) => ({
    class: [
      // Flex and Alignment
      "inline-flex items-center justify-center",

      // Shape
      "border-0 rounded-full",

      // Size
      "w-8 h-8",

      // Colors
      "bg-transparent",
      {
        "text-surface-500 dark:text-white": !context.selected,
        "text-primary-600 dark:text-white": context.selected,
        "pointer-events-none opacity-30": context.leaf,
      },

      // States
      "hover:bg-dss-surface-100 dark:hover:bg-surface-500/40",

      // Transition
      "transition duration-200",

      // Misc
      "cursor-pointer select-none",
    ],
  }),
  nodeIcon: {
    class: [
      // Space
      "mr-2",

      // Color
      "text-surface-600 dark:text-white/70",
    ],
  },
  nodeChildren: {
    class: [
      // Common styles for both UL and LI
      "m-0 list-none p-0 pl-2",
      // Direct element selector
      "[ul]:border-l [ul]:border-surface-300 [ul]:ml-8",
    ],
  },
  loadingIcon: {
    class: [
      "text-surface-500 dark:text-surface-0/70",
      "absolute top-[50%] right-[50%] -mt-2 -mr-2 animate-spin",
    ],
  },
};
